// import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import Foundation from 'foundation-sites';
import photoSwipe from 'photoswipe';
import photoSwipeDefault from '../../node_modules/photoswipe/dist/photoswipe-ui-default.js';
import 'lazysizes';
import Cookie from 'jquery.cookie';

svg4everybody();

window.$ = $;
window.jQuery = $;
Foundation.addToJquery($);
window.PhotoSwipe = photoSwipe;
window.PhotoSwipeUI_Default = photoSwipeDefault;
window.cookie = Cookie;

require('ninelines-ua-parser');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-validation');
require('../../node_modules/jquery.fias/jquery.fias.min');
